import { useState } from "react";
import { C, uid, Btn, Input, Select, Section, StatCard, useIsMobile, SEMILLAS_OPC } from "./ui";
import { toast } from "../services/toast";

export const CATEGORIAS_INSUMO = ["Gasoil", "Semilla", "Fertilizante", "Agroquímico", "Sal/Ración", "Otro"];
const UNIDAD_DEFAULT = { Gasoil:"L", Semilla:"kg", Fertilizante:"kg", "Agroquímico":"L", "Sal/Ración":"kg", Otro:"unid." };
const ICON_CAT = { Gasoil:"⛽", Semilla:"🌱", Fertilizante:"🧪", "Agroquímico":"🧴", "Sal/Ración":"🧂", Otro:"📦" };

const NOMBRES_INSUMO = {
  Gasoil:        ["Gasoil"],
  Semilla:       SEMILLAS_OPC,
  Fertilizante:  ["Urea 46%", "Fosfato (DAP)", "Superfosfato", "NPK 15-15-15", "Nitrato de amonio", "Otro fertilizante"],
  "Agroquímico": ["Glifosato", "2,4-D", "MCPA", "Atrazina", "Cipermetrina", "Otro agroquímico"],
  "Sal/Ración":  ["Ración ponedoras", "Ración parrilleros", "Ración cerdos", "Ración conejos", "Ración balanceada", "Maíz partido", "Sal mineral", "Núcleo proteico", "Otro"],
  Otro:          ["Alambre", "Postes", "Lubricantes", "Repuestos", "Herramientas", "Otro"],
};
const nombresDe = (cat) => NOMBRES_INSUMO[cat] || ["Otro"];

const CAT_EGRESO = {
  Gasoil:"Combustible", Semilla:"Semillas", Fertilizante:"Insumos agropecuarios",
  "Agroquímico":"Insumos agropecuarios", "Sal/Ración":"Insumos agropecuarios", Otro:"Otro gasto",
};

export function InsumosPanel({ insumosState, user, profile, onGasto }) {
  const isMobile = useIsMobile();
  const { insumos, createInsumo, updateInsumo, deleteInsumo } = insumosState;
  const [show, setShow]         = useState(false);
  const [nombre, setNombre]     = useState("Gasoil");
  const [categoria, setCategoria] = useState("Gasoil");
  const [cantidad, setCantidad] = useState("");
  const [unidad, setUnidad]     = useState("L");
  const [stockMin, setStockMin] = useState("");
  const [costo, setCosto]       = useState("");
  const [verHist, setVerHist]   = useState(null);
  const [confirmar, setConfirmar] = useState(null);

  const cambiarCategoria = (v) => {
    setCategoria(v);
    setUnidad(UNIDAD_DEFAULT[v] || "unid.");
    setNombre(nombresDe(v)[0]);
  };

  const hoy = () => new Date().toISOString().slice(0, 10);

  const guardar = async () => {
    if (!nombre || cantidad === "") return;
    const cant = parseFloat(cantidad) || 0;
    const costoTotal = parseFloat(costo) || 0;

    try {
      const nuevoInsumo = {
        nombre,
        categoria,
        cantidad: cant,
        unidad,
        costo_unitario: cant > 0 ? costoTotal / cant : 0,
        stock_min: parseFloat(stockMin) || 0,
      };

      await createInsumo(nuevoInsumo);

      if (costoTotal > 0 && onGasto) {
        onGasto({
          id: uid(), tipo: "egreso", categoria: CAT_EGRESO[categoria] || "Otro gasto",
          concepto: `Compra ${nombre} (${cant} ${unidad})`,
          monto: costoTotal, fecha: hoy(), obs: "Generado desde Insumos",
        });
      }

      setShow(false);
      setCantidad("");
      setStockMin("");
      setCosto("");
      toast.success("Insumo guardado.");
    } catch (e) {
      console.error("Error guardando insumo:", e);
      toast.error("No se pudo guardar el insumo: " + (e.message || "error"));
    }
  };

  const eliminar = async (id) => {
    try {
      await deleteInsumo(id);
      setConfirmar(null);
    } catch (e) {
      console.error("Error eliminando insumo:", e);
    }
  };

  const gasoil  = insumos.filter(i => i.categoria === "Gasoil").reduce((s, i) => s + (i.cantidad || 0), 0);
  const semilla = insumos.filter(i => i.categoria === "Semilla").reduce((s, i) => s + (i.cantidad || 0), 0);
  const bajos   = insumos.filter(i => i.stock_min > 0 && (i.cantidad || 0) < i.stock_min).length;

  return (
    <div style={{ flex: 1, overflowY: "auto", background: C.fondo }}>
      <div style={{ padding: isMobile ? "14px 14px" : "20px 24px", maxWidth: 900, margin: "0 auto" }}>
        <div style={{ fontFamily: "serif", fontSize: 22, color: C.tierra, fontWeight: 600, marginBottom: 4 }}>
          Insumos y stock
        </div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 18 }}>
          Gasoil, semillas y demás. Guardados en base de datos.
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(120px,1fr))", gap: 10, marginBottom: 18 }}>
          <StatCard val={`${gasoil.toLocaleString("es-UY")} L`} label="gasoil disponible" color={C.tierra} />
          <StatCard val={`${semilla.toLocaleString("es-UY")} kg`} label="semilla disponible" color={C.pasto} />
          <StatCard val={insumos.length} label="ítems en stock" />
          <StatCard val={bajos} label="bajo mínimo" color={bajos > 0 ? C.danger : C.muted} />
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
          <Btn variant="primary" onClick={() => setShow(true)}>+ Agregar insumo</Btn>
        </div>

        {show && (
          <div style={{ background: C.white, borderRadius: 12, padding: 16, marginBottom: 16, border: `1px solid ${C.arenaDark}` }}>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0 12px" }}>
              <Select label="Categoría" value={categoria} onChange={cambiarCategoria} options={CATEGORIAS_INSUMO} />
              <Select label="Nombre / producto" value={nombre} onChange={setNombre} options={nombresDe(categoria)} />
              <Input label="Cantidad" value={cantidad} onChange={setCantidad} type="number" placeholder="0" />
              <Select label="Unidad" value={unidad} onChange={setUnidad} options={["L", "kg", "g", "unid.", "bolsa"]} />
              <Input label="Costo ($)" value={costo} onChange={setCosto} type="number" placeholder="Total pagado" />
              <Input label="Stock mínimo (alerta)" value={stockMin} onChange={setStockMin} type="number" placeholder="0" />
            </div>
            {cantidad && costo && (
              <div style={{ fontSize:11, color:C.muted, marginBottom:8 }}>
                Costo unitario: <b>${((parseFloat(costo)||0)/(parseFloat(cantidad)||1)).toLocaleString("es-UY",{maximumFractionDigits:2})}</b> /{unidad}
              </div>
            )}
            <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
              <Btn variant="ghost" size="sm" onClick={() => setShow(false)} style={{ flex: 1 }}>Cancelar</Btn>
              <Btn variant="primary" size="sm" onClick={guardar} disabled={!nombre || cantidad === ""} style={{ flex: 1 }}>Guardar</Btn>
            </div>
          </div>
        )}

        {insumos.length === 0 && !show && (
          <div style={{ textAlign: "center", padding: "40px 20px", color: C.muted }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
            <div style={{ fontSize: 13 }}>Cargá tu gasoil, semillas y otros insumos para llevar el stock.</div>
          </div>
        )}

        {insumos.map((it) => {
          const bajo = it.stock_min > 0 && (it.cantidad || 0) < it.stock_min;
          return (
            <div key={it.id} style={{
              background: C.white, borderRadius: 10, padding: "10px 14px", marginBottom: 7,
              border: `1px solid ${bajo ? "#E09090" : C.arenaDark}`,
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <span style={{ fontSize: 22 }}>{ICON_CAT[it.categoria] || "📦"}</span>
                <div style={{ flex: 1, minWidth: 120 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: C.tierra }}>{it.nombre}</div>
                  <div style={{ fontSize: 11, color: C.muted }}>
                    {it.categoria}
                    {it.costo_unitario > 0 ? ` · $${it.costo_unitario.toLocaleString("es-UY",{maximumFractionDigits:2})}/${it.unidad}` : ""}
                    {it.stock_min > 0 ? ` · mín ${it.stock_min}` : ""}
                    {bajo ? <span style={{ color: C.danger, fontWeight: 600 }}> · ⚠ bajo stock</span> : ""}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 5 }}>
                  <span style={{ fontFamily: "serif", fontSize: 22, fontWeight: 700, color: C.tierra }}>
                    {(it.cantidad || 0).toLocaleString("es-UY")}
                  </span>
                  <span style={{ fontSize: 12, color: C.muted, marginRight: 4 }}>{it.unidad}</span>
                  {confirmar === it.id ? (
                    <>
                      <button onClick={() => eliminar(it.id)}
                        style={{ ...btnAdj, background: C.danger, color: "#fff", borderColor: C.danger }}>Sí</button>
                      <button onClick={() => setConfirmar(null)} style={btnAdj}>No</button>
                    </>
                  ) : (
                    <button onClick={() => setConfirmar(it.id)} title="Eliminar"
                      style={{ ...btnAdj, color: C.danger, borderColor: "#E0909055" }}>✕</button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const btnAdj = {
  background: C.arena, border: `1px solid ${C.arenaDark}`, borderRadius: 6,
  padding: "6px 9px", fontSize: 12, cursor: "pointer", color: C.tierra, fontFamily: "monospace",
};
